export default [
  {
    name: 'imprimir',
    path: '/imprimir',
    component: () =>
      import('@/components/shared/relatorio/TemplateRelatorio.vue'),
  },
]
